import { TextField } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider, DatePicker as MUIDatePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { FieldConfig, Field as FormikField, FieldProps as FormikFieldProps } from 'formik';
import React, { useEffect } from 'react';
import { TypographyProps } from '../../../../state/ducks/common/types';
import { themeNext } from '../../../layout/theme-next';
import { useFormContext } from '../FormContext';
import Field, { FieldOwnProps } from './Field';

type DatePickerPropsWithFormik = FieldOwnProps &
FormikFieldProps &
Partial<TypographyProps>;

const DatePicker: React.FC<DatePickerPropsWithFormik> = ({
  label,
  minDate,
  value,
  ...fieldProps
}) => {
  const { submitForm } = useFormContext();

  useEffect(() => {
    if (value) {
      handleDateChange(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDateChange = (date) => {
    const { form } = fieldProps;
    form.setFieldValue(fieldProps.field.name, date);
    submitForm();
  };

  return (
    <Field label={label} {...fieldProps}>
      <ThemeProvider theme={themeNext}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <MUIDatePicker
            value={fieldProps.field.value || null}
            onChange={handleDateChange}
            minDate={minDate}
            inputFormat="MM/DD/YY"
            disablePast={false}
            renderInput={(params) => (
              <TextField fullWidth size="small" {...params} />
            )}
          />
        </LocalizationProvider>
      </ThemeProvider>
    </Field>
  );
};

type DatePickerStaticFieldProps = FieldOwnProps &
FieldConfig &
Partial<TypographyProps>;

const DatePickerStaticField: React.FC<DatePickerStaticFieldProps> = (props) => (
  <FormikField component={DatePicker} {...props} />
);

export default DatePickerStaticField;
